// src/api.js

//  export const API = 'http://localhost/App/backend-web';
export const API = 'https://modulhandbuch.digitecstudieren.de/backend-web';

export function apiFetch(path, options = {}) {
  const defaultHeaders = {
    'Content-Type': 'application/json'
  };

  return fetch(`${API}/${path}`, {
    mode: 'cors',
    credentials: 'include',
    headers: {
      ...defaultHeaders,
      ...(options.headers || {}) 
    },
    ...options
  });
}
